import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  withStyles,
  CircularProgress,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Hidden,
} from '@material-ui/core'
import {
  selectConversation,
  toggleChatSearch,
  listInbox,
  setEmptyPage,
  clearNeedsFollowUp,
  clearRecentViewable,
  setNeedsFollowUp,
  setRecentViewable,
} from 'actions/inbox'
import { MoreVert, Delete, Report } from '@material-ui/icons'
import {
  AccountMinus,
  AccountPlus,
  ClockMinus,
  ClockPlus,
} from 'mdi-material-ui'
import { read, deleteEntity } from 'actions/data'
import { receiveContact } from 'actions/contacts/addOrEdit'
import classNames from 'classnames'
import { conversationsInInboxSearch } from 'selectors/inbox'
import moment from 'moment'
import SmallAvatar from './SmallAvatar'
import contactLabel from 'utils/contactLabel'
import { capitalize } from 'lodash'
import { PencilPlus } from 'mdi-material-ui'
import Button from 'components/theme/Button'
import { withRouter } from 'react-router-dom'
import {
  List as VirtualizedList,
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
  InfiniteLoader,
} from 'react-virtualized'
import API_URL from 'utils/ApiUrl'
import { toggleDialog } from 'actions/view'
import { Auth } from 'utils/Auth'

const styles = theme => ({
  conversationListItem: {
    borderBottom: '1px solid #e5e5e5',
    borderRight: '1px solid #e5e5e5',
    minHeight: 83,
    position: 'relative',
    cursor: 'pointer',
    padding: '11px 37px 11px 60px',
  },
  avatar: {
    position: 'absolute',
    top: 17,
    left: 10,
  },
  avatarUser: { backgroundColor: theme.palette.secondary.main },
  moreButton: {
    position: 'absolute',
    right: 4,
    top: 20,
    padding: 4,
  },
  newHeading: {
    fontSize: theme.typography.pxToRem(15),
    display: 'table',
    tableLayout: 'fixed',
    width: '100%',
    whiteSpace: 'nowrap',
    marginBottom: 5,
  },
  createdHeading: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.pxToRem(15),
    display: 'table',
    tableLayout: 'fixed',
    width: '100%',
    whiteSpace: 'nowrap',
  },
  text: {
    display: 'table-cell',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  createdDate: {
    display: 'inline-block',
  },
  selectedBackground: {
    backgroundColor: '#c0defb',
    [theme.breakpoints.down('sm')]: {
      backgroundColor: '#fff',
    },
  },
  selectedText: {
    fontWeight: 'bold',
  },
  moreIconButton: {
    position: 'absolute',
    right: 6,
    top: 19,
  },
  iconButtonRoot: {
    padding: 8,
  },
})

class ConversationListItemComponent extends Component {
  state = { anchorEl: null }

  componentDidMount() {
    if (
      this.props.lastConversationItem?.formsub?.id &&
      !this.props.customFormName
    ) {
      this.props.read(this.props.lastConversationItem.formsub.id, 'customform')
    }
  }

  handleClick = event => {
    event.stopPropagation()
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = event => {
    if (event) {
      event.stopPropagation()
    }
    this.setState({ anchorEl: null })
  }

  handleAction = async (contactID, actionType) => {
    let endpoint
    let action

    // Determine the appropriate endpoint and action based on the actionType
    switch (actionType) {
      case 'setNeedsFollowUp':
        endpoint = `${API_URL}/inbox/needsfollowup/set/${contactID}`
        action = this.props.setNeedsFollowUp
        break
      case 'clearNeedsFollowUp':
        endpoint = `${API_URL}/inbox/needsfollowup/clear/${contactID}`
        action = this.props.clearNeedsFollowUp
        break
      case 'clearRecentViewable':
        endpoint = `${API_URL}/inbox/recentviewable/clear/${contactID}`
        action = this.props.clearRecentViewable
        break
      case 'setRecentViewable':
        endpoint = `${API_URL}/inbox/recentviewable/set/${contactID}`
        action = this.props.setRecentViewable
        break
      default:
        return
    }

    try {
      const session = await Auth.currentSession()
      const response = await fetch(endpoint, {
        cache: 'no-cache',
        headers: {
          'content-type': 'application/json',
          authorization: `Bearer ${session.idToken.jwtToken}`,
        },
        method: 'PUT',
        mode: 'cors',
        redirect: 'follow',
        referrer: 'no-referrer',
      })

      const data = await response.json()
      if (!response.ok) {
        return { notOk: true, ...data }
      }

      action(contactID)
      console.log('data: ', data)
      return data
    } catch (error) {
      console.error('Error handling request:', error)
    }
  }

  render() {
    const {
      classes,
      selectConversation,
      selected,
      read,
      recentlySent,
      toggleChatSearch,
      contactID,
      // last_inbound,
      // last_outbound,
      last_interaction,
      contact,
      lastConversationItem,
      customFormName,
      conversationsListFilter,
      hasBeenDeleted,
    } = this.props

    let description = null

    if (lastConversationItem?.sms?.body) {
      description = lastConversationItem.sms.body
    }

    if (lastConversationItem?.thread?.emails?.[0]?.subject) {
      description = 'subject: ' + lastConversationItem.thread.emails[0].subject
    }

    if (lastConversationItem?.call && lastConversationItem?.direction) {
      description = `${capitalize(lastConversationItem.direction)} call`
    }

    if (lastConversationItem?.formsub) {
      description = `Answered form '${customFormName}'`
    }

    const timeStamp =
      recentlySent && Array.isArray(recentlySent) && recentlySent.length
        ? recentlySent[recentlySent.length - 1].timestamp
        : last_interaction || null
    const date =
      timeStamp &&
      (moment(timeStamp).isSame(new Date().toISOString(), 'Date')
        ? moment(timeStamp).format('h:mm A')
        : moment(timeStamp).format('MM/DD/YYYY'))

    // this is the current bolding logic:
    const unanswered = () => {
      // if (last_inbound) {
      //   if (!last_outbound) return true

      //   if (Date.parse(last_outbound) < Date.parse(last_inbound)) {
      //     return true
      //   }
      // }

      // return false
      return this.props.needsfollowup
    }

    const removeMenuItem =
      conversationsListFilter ===
      'recent/out_r' ? null : conversationsListFilter === 'recent/followup' ||
        (conversationsListFilter === 'all' && this.props.needsfollowup) ? (
        <MenuItem
          onClick={e => {
            e.stopPropagation()
            this.handleClose()
            console.log('Doesnt need follow up')
            this.handleAction(contactID, 'clearNeedsFollowUp')
          }}
        >
          <AccountMinus
            style={{
              marginRight: 12,
              color: 'rgba(0, 0, 0, 0.54)',
            }}
          />
          Doesn't need follow up
        </MenuItem>
      ) : conversationsListFilter?.slice(0, 6) === 'recent' ? (
        <MenuItem
          onClick={e => {
            e.stopPropagation()
            this.handleClose()
            console.log('Remove from recent')
            this.handleAction(contactID, 'clearRecentViewable')
          }}
        >
          <ClockMinus
            style={{
              marginRight: 12,
              color: 'rgba(0, 0, 0, 0.54)',
            }}
          />
          Remove from recent
        </MenuItem>
      ) : null

    const setNeedsFollowUpItem =
      conversationsListFilter !== 'recent/followup' &&
      !(conversationsListFilter === 'all' && this.props.needsfollowup) ? (
        <MenuItem
          onClick={e => {
            e.stopPropagation()
            this.handleClose()
            console.log('Needs follow up')
            this.handleAction(contactID, 'setNeedsFollowUp')
          }}
        >
          <AccountPlus
            style={{
              marginRight: 12,
              color: 'rgba(0, 0, 0, 0.54)',
            }}
          />
          Needs follow up
        </MenuItem>
      ) : null

    const noRecentObj = {
      'recent/all': true,
      'recent/in': true,
      'recent/out': true,
    }

    const setRecentViewableItem = noRecentObj[
      conversationsListFilter
    ] ? null : (
      <MenuItem
        onClick={e => {
          e.stopPropagation()
          this.handleClose()
          console.log('Add to recent')
          this.handleAction(contactID, 'setRecentViewable')
        }}
      >
        <ClockPlus
          style={{
            marginRight: 12,
            color: 'rgba(0, 0, 0, 0.54)',
          }}
        />
        Add to recent
      </MenuItem>
    )

    const deleteItem = mobile => (
      <MenuItem
        onClick={() => {
          if (
            window.confirm('Are you sure you want to delete this conversation?')
          ) {
            this.handleClose()
            this.props.deleteConversation(this.props.contact?.id, mobile)
          }
        }}
      >
        <Delete
          style={{
            marginRight: 12,
            color: 'rgba(0, 0, 0, 0.54)',
          }}
        />
        Delete conversation
      </MenuItem>
    )

    async function makeRequests({ putUrls }) {
      const session = await Auth.currentSession()

      const putRequests = putUrls.map(url =>
        fetch(url, {
          cache: 'no-cache',
          method: 'PUT',
          mode: 'cors',
          redirect: 'follow',
          referrer: 'no-referrer',
          headers: {
            'content-type': 'application/json',
            authorization: `Bearer ${session.idToken.jwtToken}`,
          },
        }),
      )

      try {
        const results = await Promise.allSettled(putRequests)

        results.forEach((result, index) => {
          if (result.status === 'fulfilled') {
            console.log(`PUT request succeeded for ${putUrls[index]}`)
          } else {
            console.error(
              `PUT request failed for ${putUrls[index]}: ${result.reason}`,
            )
          }
        })

        // Trigger your action here once all requests are completed
        console.log('All PUT requests have been completed.')
      } catch (error) {
        console.error('Error making requests:', error)
      }
    }

    const blockItem = mobile => (
      <MenuItem
        onClick={() => {
          if (
            window.confirm(
              'This will mark all contact methods for this ' +
                'contact as spam & delete the conversation. Are ' +
                'you sure you want to do this?',
            )
          ) {
            this.handleClose()
            const emailUrls =
              this.props.contact?.email
                ?.filter?.(emailObj => typeof emailObj?.id === 'string')
                ?.map?.(
                  emailObj => `${API_URL}/contact/email/${emailObj.id}/isspam`,
                ) || []
            const phoneUrls =
              this.props.contact?.phones
                ?.filter?.(phonesObj => typeof phonesObj?.id === 'string')
                ?.map?.(
                  phonesObj =>
                    `${API_URL}/contact/phone/${phonesObj.id}/isspam`,
                ) || []

            makeRequests({ putUrls: [...emailUrls, ...phoneUrls] }).then(() => {
              this.props.deleteConversation(this.props.contact?.id, mobile)
            })
          }
        }}
      >
        <Report
          style={{
            marginRight: 12,
            color: 'rgba(0, 0, 0, 0.54)',
          }}
        />
        Block
      </MenuItem>
    )

    return (
      <div
        className={classNames(
          classes.conversationListItem,
          selected ? classes.selectedBackground : null,
        )}
        onClick={event => {
          if (!this.state.anchorEl) {
            toggleChatSearch(false)
            Promise.resolve(selectConversation(null))
              .then(() => selectConversation(contactID))
              .then(() => {
                read(contactID, 'inbox', 'inbox/conversation', 'contact_id')
              })
          } else {
            event.stopPropagation()
          }
        }}
      >
        <div className={classes.avatar}>
          {contact ? (
            <SmallAvatar hasBeenDeleted={hasBeenDeleted} contact={contact} />
          ) : (
            <CircularProgress />
          )}
        </div>
        <Grid container>
          <Grid item xs={12}>
            <div className={classes.newHeading}>
              <span
                className={classNames(
                  classes.text,
                  unanswered() ? classes.selectedText : null,
                )}
                style={
                  hasBeenDeleted
                    ? {
                        textDecoration: 'line-through',
                        color: 'rgba(0, 0, 0, 0.54)',
                      }
                    : {}
                }
              >
                {contact ? contactLabel(contact) : 'Loading...'}
                {/* {hasBeenDeleted ? '(deleted)' : ''} */}
              </span>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.createdHeading}>
              <div className={classes.text}>
                <div
                  style={{
                    width: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                  className={classes.createdDate}
                >
                  {description}
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xs={12}>
            {date}
          </Grid>
        </Grid>
        <div
          style={{
            position: 'absolute',
            right: 3,
            top: '50%',
            transform: 'translateY(-50%)',
          }}
        >
          <IconButton
            aria-owns={
              this.state.anchorEl ? `deleteMenuConversation` : undefined
            }
            aria-haspopup="true"
            style={{ padding: 5 }}
            onClick={this.handleClick}
          >
            <MoreVert />
          </IconButton>
        </div>
        <Menu
          anchorEl={this.state.anchorEl}
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleClose}
          onClick={event => event.stopPropagation()}
        >
          <Hidden mdUp>
            {removeMenuItem}
            {setRecentViewableItem}
            {setNeedsFollowUpItem}
            {blockItem(true)}
            {deleteItem(true)}
          </Hidden>
          <Hidden smDown>
            {removeMenuItem}
            {setRecentViewableItem}
            {setNeedsFollowUpItem}
            {blockItem()}
            {deleteItem()}
          </Hidden>
        </Menu>
      </div>
    )
  }
}

const deleteConversation = (contactID, mobile) => (dispatch, getState) =>
  dispatch(
    deleteEntity(
      contactID,
      'inbox',
      `${API_URL}/inbox/conversation/${contactID}`,
      'Conversation deleted',
    ),
  ).then(() =>
    dispatch(selectConversation(null)).then(() => {
      if (!mobile) {
        const sort = (a, b) => {
          if (a.last_interaction === '0001-01-01T00:00:00Z') return -1
          if (b.last_interaction === '0001-01-01T00:00:00Z') return 1
          return new Date(b.last_interaction) - new Date(a.last_interaction)
        }
        const latestConversationID =
          Object.values(getState().data?.inbox || {})
            ?.sort((a, b) => sort(a, b))
            .slice(0, 1)?.[0]?.contact_id || null

        return dispatch(selectConversation(latestConversationID)).then(() => {
          if (latestConversationID) {
            return dispatch(
              read(
                latestConversationID,
                'inbox',
                'inbox/conversation',
                'contact_id',
              ),
            )
          }
          return
        })
      }
      return
    }),
  )

const ConversationListItem = connect(
  (state, { /* conversation,  */ contactID }) => {
    const conversationsListFilter = state.inbox.conversationsListFilter
    const conversation =
      conversationsListFilter === 'all'
        ? state.data?.inbox?.[contactID]
        : state.inbox.conversationsListCursor?.[conversationsListFilter]
            ?.data?.[contactID]
    const hasBeenDeleted = conversation.has_been_deleted
    const lastConversationItem = conversation?.conversation?.[0]

    return {
      customFormName:
        state.data?.customform?.[lastConversationItem?.formsub?.id]?.name,
      selected: state.inbox.conversationSelected === conversation?.contact_id,
      contact: conversation?.contact,
      lastConversationItem,
      last_interaction: conversation?.last_interaction,
      last_inbound: conversation?.last_inbound,
      last_outbound: conversation?.last_outbound,
      conversationsListFilter,
      needsfollowup:
        state.inbox.conversationsListCursor.needsfollowup.data?.[contactID],
      hasBeenDeleted,
    }
  },
  dispatch =>
    bindActionCreators(
      {
        selectConversation,
        read,
        receiveContact,
        toggleChatSearch,
        deleteEntity,
        deleteConversation,
        clearNeedsFollowUp,
        clearRecentViewable,
        setNeedsFollowUp,
        setRecentViewable,
      },
      dispatch,
    ),
)(withStyles(styles)(ConversationListItemComponent))

const Empty = withRouter(
  connect(
    state => {
      const selectedEndpoint = state.inbox.conversationsListFilter
      return {
        contactsLength: Object.keys(state.contacts.contactsWithEmailsByID)
          .length,
        loading:
          state.inbox.conversationsListCursor?.[selectedEndpoint]?.loading,
      }
    },
    dispatch => bindActionCreators({ toggleDialog }, dispatch),
  )(({ toggleDialog, contactsLength, history, loading }) => (
    <div
      style={{
        borderBottom: '1px solid #e5e5e5',
        borderRight: '1px solid #7f7f7f',
        minHeight: 83,
        position: 'relative',
        cursor: 'pointer',
        padding: '11px 37px 11px 60px',
      }}
      onClick={() =>
        contactsLength && !loading
          ? toggleDialog({
              open: true,
              dialog: 'contactList',
              options: {
                type: 'inbox',
              },
            })
          : null
      }
    >
      {loading ? (
        'Loading...'
      ) : contactsLength ? (
        <Fragment>
          Start a new conversation
          <PencilPlus
            style={{
              color: 'rgba(0, 0, 0, 0.54)',
              position: 'absolute',
              right: 25,
            }}
          />
        </Fragment>
      ) : (
        <Button
          onClick={() => history.push('/contacts/new')}
          variant="contained"
          color="secondary"
          size="small"
        >
          Add a new contact
        </Button>
      )}
    </div>
  )),
)

class ConversationList extends Component {
  constructor() {
    super()
    this.cache = new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 106,
    })
  }

  componentDidMount() {
    window.listInbox = this.props.listInbox

    this.props.listInbox({ endpoint: 'needsfollowup' })
  }

  componentDidUpdate(prevProps) {
    if (this.props.lastInteraction !== prevProps.lastInteraction) {
      if (this.cache) {
        this.cache.clearAll()
      }
      if (this?.normalList && this.normalList?.forceUpdateGrid) {
        this.normalList.forceUpdateGrid()
      }
    }
  }

  recursiveList = (empty, endpoint) => {
    console.log('recursiveList')
    if (empty) {
      return this.props
        .listInbox({ infiniteLoader: true, recursive: true, endpoint })
        .then(payload =>
          this.recursiveList(
            payload?.cursor && !payload?.response?.length,
            endpoint,
          ),
        )
    } else {
      this.props.setEmptyPage(false)
      return
    }
  }

  loadMoreRows = () => {
    const {
      loading,
      listInbox,
      // conversationsListCursor,
      conversationsListFilter,
    } = this.props

    if (loading) {
      return () => {}
    }

    return () => {
      const endpoint = conversationsListFilter
      listInbox({ infiniteLoader: true, endpoint }).then(payload => {
        if (payload?.cursor && !payload?.response?.length) {
          this.recursiveList(true, endpoint)
        }
      })
    }
  }

  isRowLoaded = ({ index }) => {
    const { conversationsListCursor, conversations } = this.props
    return !conversationsListCursor || index < conversations.length
  }

  rowRenderer = ({ index, key, style, parent }) => {
    return (
      <CellMeasurer
        key={key}
        cache={this.cache}
        parent={parent}
        columnIndex={0}
        rowIndex={index}
      >
        <div style={style}>
          {!this.isRowLoaded({ index }) ? (
            <div
              key="inboxPageConversationListItem_Loading"
              style={{
                borderBottom: '1px solid #e5e5e5',
                borderRight: '1px solid #7f7f7f',
                minHeight: 83,
                position: 'relative',
                cursor: 'pointer',
                padding: '11px 37px 11px 60px',
              }}
            >
              Loading...
            </div>
          ) : (
            this.listItem(index)
          )}
        </div>
      </CellMeasurer>
    )
  }

  list = () => this.props.conversations

  listItem = index => {
    const conversation = this.list()[index]
    return (
      <ConversationListItem
        key={`inboxPageConversationListItem${
          (conversation && conversation.contact_id) || index
        }`}
        contactID={conversation?.contact_id}
      />
    )
  }

  bindListRef = ref => {
    this.normalList = ref
  }

  render() {
    const { conversations, conversationsListCursor /* , loading */ } =
      this.props
    const list = this.list()

    return (
      <div
        style={{
          height: 'calc(100% - 60px)',
        }}
      >
        {conversations.length ? (
          <InfiniteLoader
            isRowLoaded={this.isRowLoaded}
            loadMoreRows={this.loadMoreRows()}
            rowCount={conversationsListCursor ? list.length + 1 : list.length}
          >
            {({ onRowsRendered, registerChild }) => (
              <AutoSizer>
                {({ width, height }) => (
                  <VirtualizedList
                    ref={registerChild}
                    onRowsRendered={onRowsRendered}
                    width={width}
                    height={height}
                    deferredMeasurementCache={this.cache}
                    rowHeight={this.cache.rowHeight}
                    rowRenderer={this.rowRenderer}
                    rowCount={
                      conversationsListCursor ? list.length + 1 : list.length
                    }
                    overscanRowCount={3}
                  />
                )}
              </AutoSizer>
            )}
          </InfiniteLoader>
        ) : (
          <Empty />
        )}
      </div>
    )
  }
}

export default connect(
  state => {
    const conversationsListFilter = state.inbox.conversationsListFilter
    return {
      conversations: conversationsInInboxSearch(state),
      contactSelected: state.inbox.contactSelected,
      lastInteraction: state.data?.['inbox/last']?.last_interaction,
      conversationsListCursor:
        state.inbox.conversationsListCursor?.[conversationsListFilter]?.cursor,
      loading:
        state.inbox.conversationsListCursor?.[conversationsListFilter]?.loading,
      // conversationsListFilter,
      conversationsListUserFilter:
        state.inbox.conversationsListUserFilter.filter,
      emptyPage:
        state.inbox.conversationsListCursor?.[conversationsListFilter]
          ?.emptyPage,
    }
  },
  dispatch => bindActionCreators({ listInbox, setEmptyPage }, dispatch),
)(ConversationList)
